import { useEffect, useState } from 'react';
import React from 'react';

import { Spin, Space, Button, message, Form, DatePicker, Input } from 'antd';
import dayjs from 'dayjs';

import sessionManager, { eVariableType } from '../../../SessionManager';
import api from '../../../api';
import stringres from '../../../translations/stringres';
import ComboEventiTipi from '../../Combos/ComboEventiTipi';

export default function EventoClienteAddEdit(props) {
    const { evento } = props;
    const { codCliente } = props;
    const { confirm } = props;

    const { TextArea } = Input;
    const [form] = Form.useForm();

    const [isLoadingSave, setIsLoadingSave] = useState(false);

    useEffect(() => {
        async function loadData() {
            if (evento == null) return;

            try {
                form.setFieldValue('descrizioneEvento', evento.descrizioneEvento);
                form.setFieldValue('dataScadenza', dayjs(evento.dataScadenza));
                form.setFieldValue('idTipoEvento', dayjs(evento.idTipoEvento));

                console.log(evento);
            } catch (error) {
                message.error(error, 5);
            }
        }

        loadData();
    }, [evento, form]);

    async function Salva() {
        try {
            setIsLoadingSave(true);

            const request = {
                idEvento: evento?.idEvento,
                idSocieta: sessionManager.get(eVariableType.IDSocieta),
                idOperatore: sessionManager.get(eVariableType.IDOperatore),
                descrizioneEvento: form.getFieldValue('descrizioneEvento'),
                dataScadenza: form.getFieldValue('dataScadenza'),
                idTipoEvento: form.getFieldValue('idTipoEvento'),
                codCliente: codCliente,
            };
            const result = await api.post('CRM/Clienti/EventiCliente/InsertUpdate', request);

            if (result != null && result.data != null) {
                message.success(stringres.t('successo'));

                form.resetFields();

                confirm(true);
            } else {
                message.error(result.statusTextat);
            }
        } catch (error) {
            message.error(error.message, 5);
        } finally {
            setIsLoadingSave(false);
        }
    }

    return (
        <Spin spinning={isLoadingSave}>
            <Form form={form} onFinish={Salva}>
                <Form.Item name="descrizioneEvento" rules={[{ required: true }]}>
                    <TextArea rows={3} placeholder={stringres.t('descrizioneevento')}></TextArea>
                </Form.Item>
                <Form.Item>
                    <Form.Item name="dataScadenza">
                        <DatePicker placeholder={stringres.t('datascadenza')} showTime format="YYYY-MM-DD HH:mm" />
                    </Form.Item>
                </Form.Item>
                <Form.Item name="idTipoEvento" rules={[{ required: true }]}>
                    <ComboEventiTipi
                        value={form?.getFieldValue('idTipoEvento')}
                        placeholder={stringres.t('tipoevento')}
                        onChange={(value) => form.setFieldsValue({ idTipoEvento: value })}
                    ></ComboEventiTipi>
                </Form.Item>
                <Form.Item style={{ textAlign: 'end', marginTop: '15px' }}>
                    <Space>
                        <Button style={{ width: '120px' }} type="primary" htmlType="submit">
                            {stringres.t('conferma')}
                        </Button>
                        <Button style={{ width: '120px' }} type="primary" onClick={() => confirm(false)}>
                            {stringres.t('annulla')}
                        </Button>
                    </Space>
                </Form.Item>
            </Form>
        </Spin>
    );
}
